/* eslint-disable max-len */
export default {
  en: {
    ci_cd: {
      errorsHeader: 'Errors',
      configuraion: 'CI/CD Configuraion',
      createNotAvailable: 'The pipeline cannot be created because the repository is empty',
      configurationDescription:
        'To get started with CI/CD, use one of the templates below to create a configuration depending on your programming language, framework, or goals.',
      createConfiguration: 'Create Configuration',
      createCommit: 'Create Commit',
      yaml: {
        yamlLocation: {
          yamlParsing: '.yaml parsing',
          yamlProcessing: '.yaml processing',
          include: 'include',
          jobs: 'jobs',
          rules: 'rules',
          rule: 'rule [{0}]',
          field: 'field {0}',
          variable: 'variable {0}',
          includeProject: 'include project {0}',
          // локация без локализации, например имя джоба
          customNoLoc: '{0}'
        },
        yamlError: {
          // ошибка без локализации, например синт. ошибка в правиле
          customNoLoc: '{0}',
          fieldsIncompatible: "the field cannot be used with '{0}'",
          stageDoesNotExist: 'stage {0} does not exist; available stages: {1}',
          invalidExpireInFormat: 'Incorrect ExpireIn input format, see docs',
          triggerShouldContainProjectOrInclude:
            'trigger should contain trigger:project or trigger:include',
          invalidCountOfVisibleJobs: 'config should contain at least one visible job',
          invalidCountOfVisibleJobsAfterRules:
            'the config does not contain jobs after applying the rules',
          invalidNeedsConfiguration:
            'the job {0} should be in the same stage as {1} or in any of the consequent ones',
          invalidRulesNeedsDependencies:
            '{0} job needs {1} job, but it is not in any previous stage',
          nonTriggerJobShouldContainScripts:
            'all jobs that do not have the "trigger” keyword should implement “scripts”',
          cantBeBlank: "can't be blank",
          invalidVariableKey: "variable key can only contain letters, numbers, and '_'",
          circularVariableReference: 'circular variable reference detected: {0}',
          jobVariableCountLimit: 'the number of job variables exceeds the limit in {0} variables',
          jobVariablesSizeLimit:
            'the total size of the job variables exceeds the limit of {0} characters',
          wrongIncludeFileExtension: 'included file "{0}" does not have YAML extension',
          IncludeFileDoesNotExist: 'file {0} does not exist',
          includeProjectNotFound: 'project {0} not found',
          refDoesNotExist: 'reference {0} does not exist',
          invalidRemoteUrl: 'value is not a valid URL: {0}',
          valueNotAString: 'value {0} must be a string, try wrapping it in single quotes',
          invalidEnvironmentAction: `invalid values - {0}, available values - {1}`,
          onStopJobIsNotDefined: `declared stop job does not exist - {0}`,
          environmentIsNotDefined: `environment is not declared in stop job - {0}`,
          differentEnvironmentName: `different environments declared - {0}`,
          actionStopIsNotDefined: `action value is not 'stop' in stop job {0}`,
          blankEnvironmentName: `environment name is not declared`,
          wrongEnvironmentName: `environment name can contain only latin letters, digits, «-», «_», «/», «$», «{», «}» and spaces, but it cannot start or end with "/"`,
          // ошибка для джобы
          environmentIsProtected: `The environment this job is deploying to is protected. Only users with permission may successfully run this job.`,
          valueShouldBeStringArray: 'should be an array of strings',
          valueShouldBeArray: 'should be an array',
          valueShouldBeInOptions: 'value must be present in options',
        }
      },
      pipeline: {
        run: 'Run Pipeline',
        createPipeline: 'Creating Pipeline',
        chooseRefPipeline: 'Select tag | Select branch',
        restartVariables: {
          forTag: 'Are you sure you want to reset the variable cache in tag {0}?',
          forBranch: 'Are you sure you want to flush the variable cache on branch {0}?'
        } ,
        clearRunnerCaches: 'Clear Runner Caches',
        descriptionVariables: "Specify the values of the variables that will be used in this run. By default, the variables specified in the configuration file are used, as well as <a target=\"_blank\" href=\"https://docs.gitflic.ru/cicd/cicd-settings/#variables\">CI/CD settings</a>.<br>Variables specified here are <b>expanded</b> rather than <b>masked</b>",
        clearVariablesCaches: 'Clear Caches',
        clearRunnerCachesConfirmation: 'Are you sure you want to clear new runner caches?',
        clearRunnerCachesDescription: 'The cache will be cleared for all new runners.',
        configuration: 'Pipeline configuration',
        restart: 'Restart',
        restartConfirmation: 'Are you sure you want to restart all tasks except success?',
        cancelPipeline: 'Cancel Pipeline',
        cancelConfirmation: 'Are you sure you want to cancel this pipeline?',
        deleteConfirmation: 'Are you sure you want to delete this pipeline?',
        isRunning: 'Pipeline is running!',
        runnerCacheCleared: 'All new runner caches cleared!',
        deleted: 'Pipeline deleted!',
        delete: 'Delete',
        cancel: 'Cancel',
        confirm: 'Confirm',
        noUser: 'No User',
        pipelineStatus: 'Status',
        pipelineConveyor: 'Conveyor',
        pipelineInitiator: 'Initiator',
        pipelineCommit: 'Commit',
        pipelineStages: 'Stages',
        pipelineDuration: 'Duration',
        pipelineTaskId: 'Task ID',
        pipelineTitle: 'Title',
        pipelineCovering: 'Covering',
        pipelineRestartMessage: 'Restart',
        pipelineNoLinkedMR: 'No linked merge request',
        pipelineLinkedMR: 'Linked merge request',
        pipelineRestartMessageTooltip: 'Restarting pipelines | There is no job to restart',
        PipeRestartMessageTooltip: 'Restarting pipelines | Restarting conveyors is prohibited',
        create: 'Create Pipeline',
        configurationNotFound:
          'The CI/CD configuration file specified in the project settings is not found in the standard branch.',
        configurationNotFoundSolution:
          'Specify | a current configuration file or | create a new one',
        templateConfiguration: {
          title: 'CI/CD Template configuration',
          editedItem: 'Continuous Integration and Deployment template for {0} project',
          publishedItem: {
            title:
              'Continuous Integration and Deployment Template for publishing an application to {0}.',
            files: 'Files {0} will be added to the repository.'
          },
          create: 'Create CI/CD template configuration',
          createDescription:
            'You can edit the configuration file template below depending on your needs. For more details on syntax and keywords, please refer to | documentation',
          createDiscard: 'Are you sure you want to cancel the creation of the configuration?',
          basic: 'Basic Template GitFlic',
          basicDescription:
            'To learn how CI/CD pipelines work and customize your configuration, use the test template to create your first one',
          basicAdded: 'Added basic pipeline configuration template'
        },
        parentWasDeleted: 'The parent pipeline has been removed',
        childWasDeleted: 'The child pipeline was removed',
        mergeResultPipeline: 'Merge result pipeline',
        mergeRequestPipeline: 'Merge request pipeline',
        trainPipeline: 'Merge Train'
      },
      job: {
        jobLogRunning: 'Job is running...',
        jobUploadMore: 'Upload More',
        jobCancel: 'Cancel',
        jobConfirm: 'Confirm',
        jobLogError: 'An error occurred while loading logs. Try reloading the page.',
        jobReload: 'Reload',
        jobNoAccess: 'No Access',
        jobNoLogs: 'No Logs',
        jobConveyor: 'Conveyor',
        jobConveyorFor: 'for',
        jobStageSelect: 'Choose Stage',
        jobDuration: 'Duration',
        jobRunner: 'Runner',
        jobCommit: 'Commit',
        jobNoData: 'No Data',
        jobRestartConfirmation: 'Are you sure you want to restart the job?',
        jobCancelConfirmation: 'Are you sure you want to cancel the job?',
        jobFailedTitle: 'Title',
        jobFailedStage: 'Stage',
        jobFailedFail: 'Fail',
        jobStatus: 'Status',
        jobTask: 'Task',
        jobInitiator: 'Initiator',
        jobStage: 'Stage',
        jobName: 'Name',
        jobCovering: 'Covering',
        jobRetried: 'Retried'
      },
      stages: {
        stageReload: 'Are you sure you want to restart all tasks except success?'
      },
      artifact: {
        artifactNumber: 'Number',
        artifactJob: 'Job',
        artifactFile: 'File',
        artifactFileType: 'File Type',
        artifactExpireAt: 'Expire At',
        artifactExpireAtNever: 'Never',
        artifactNone: 'No Artifacts',
        artifactDeleteConfirmation: 'Are you sure you want to delete artifact?',
        artifactUnlockConfirmation:
          'The artifact has expired. When unlocked, downloading artifact will not be available.',
        artifactUnlockConfirmationHead: 'Attention please',
        artifactCancel: 'Cancel',
        artifactConfirm: 'Confirm',
        artifactFilter: 'Show only current tasks',
        artifactDelete: 'Delete',
        artifactDownload: 'Download',
        artifactIsDeleted: 'Artifact is deleted',
        artifactLocked: 'Locked',
        artifactUnlocked: 'Unlocked'
      },
      scheduler: {
        schedulerTitle: 'Pipeline Scheduler',
        schedulerScheduleTitle: 'Pipelines Schedules',
        schedulerNewSchedule: 'New Schedule',
        schedulerNoSchedules: 'Schedules Not Found',
        schedulerCancel: 'Cancel',
        schedulerConfirm: 'Confirm',
        schedulerCreateTitle: 'Create Schedule',
        schedulerChooseBranch: 'Choose Branch',
        schedulerChooseBranchMessage: 'Choose Branch *',
        schedulerChooseTag: 'Choose Tag',
        schedulerChooseTagMessage: 'Choose Tag *',
        schedulerConfigFilePath: 'CI/CD configuration file path',
        schedulerConfigFilePathDescription:
          'The path to the configuration file is specified from the root directory',
        schedulerTimeZoneSelect: 'Timezone Select',
        schedulerCronExpression: 'Cron-expression',
        schedulerDescriptionTitle: 'Description',
        schedulerVariablesTitle: 'Variables',
        schedulerCreate: 'Create',
        schedulerShowValues: 'Show Values',
        schedulerHideValues: 'Hide Values',
        schedulerEditTitle: 'Schedule Edit',
        schedulerEditSave: 'Save',
        scheduleSettings: 'Settings',
        scheduleActivate: 'Activate',
        scheduleDeactivate: 'Deactivate',
        scheduleActivated: 'Activated',
        scheduleDeactivated: 'Deactivated',
        scheduleStatusTitle: 'Status',
        scheduleTargetTitle: 'Target',
        scheduleDescriptionTitle: 'Description',
        scheduleConfigurationTitle: 'Configuration',
        scheduleAuthorTitle: 'Author',
        scheduleScheduleTitle: 'Schedule',
        scheduleDelete: 'Delete',
        scheduleVariableKey: 'Key',
        scheduleVariableValue: 'Value',
        scheduleActivateConfirmation: 'Are you sure you want to activate schedule?',
        scheduleDeactivateConfirmation: 'Are you sure you want to deactivate schedule?',
        scheduleDeleteConfirmation: 'Are you sure you want to delete schedule?'
      }
    }
  },
  ru: {
    ci_cd: {
      errorsHeader: 'Ошибки',
      configuraion: 'Конфигурация CI/CD',
      createNotAvailable: 'Невозможно создать конвейер, потому что репозиторий пустой',
      configurationDescription:
        'Чтобы начать работу с CI/CD, используйте один из приведенных ниже шаблонов для создания конфигурации в зависимости от языка программирования, фреймворка или целей.',
      createConfiguration: 'Создать конфигурацию',
      createCommit: 'Создать коммит',
      yaml: {
        yamlLocation: {
          yamlParsing: 'парсинг .yaml',
          yamlProcessing: 'обработка .yaml',
          include: 'поле include',
          jobs: 'задачи',
          rules: 'правила',
          rule: 'правило [{0}]',
          field: "поле '{0}'",
          variable: 'переменная {0}',
          includeProject: 'инъекция проекта {0}',
          // локация без локализации, например имя джоба
          customNoLoc: '{0}'
        },
        yamlError: {
          // ошибка без локализации, например синт. ошибка в правиле
          customNoLoc: '{0}',
          fieldsIncompatible: "это поле нельзя использовать с '{0}'",
          stageDoesNotExist: 'этапа {0} не существует; возможные этапы: {1}',
          invalidExpireInFormat:
            'некорректный формат ввода expireIn, смотрите допустимые значения в документации',
          triggerShouldContainProjectOrInclude:
            'триггер должен содержать trigger:project или trigger:include',
          invalidCountOfVisibleJobs:
            'конфигурация пайплайна должна содержать как минимум одну задачу',
          invalidCountOfVisibleJobsAfterRules:
            'конфиг не содержит ни одной задачи после применения правил',
          invalidNeedsConfiguration:
            'этап задачи {0} должен быть таким же как для задачи {1} или одним из следующих',
          invalidRulesNeedsDependencies:
            'для выполнения {0} требуется выполнение {1}, но она не находится ни на одной из предыдущих стадий',
          nonTriggerJobShouldContainScripts:
            'все задачи, которые не содержат поле "trigger", должны содержать поле "scripts"',
          cantBeBlank: 'не может быть пустым',
          invalidVariableKey:
            'название переменной должно состоять только из букв, цифр и знака нижнего подчеркивания',
          circularVariableReference: 'обнаружен цикл в переменных: {0}',
          jobVariableCountLimit:
            'количество переменных задачи превышает ограничение в {0} переменных',
          jobVariablesSizeLimit:
            'общий размер переменных задачи превышает ограничение в {0} символов',
          wrongIncludeFileExtension:
            'внешний конфигурационный файл "{0}" должен иметь расширение YAML',
          IncludeFileDoesNotExist: 'файл "{0}" не существует',
          includeProjectNotFound: 'проект {0} не найден',
          refDoesNotExist: 'ссылка "{0}" не существует',
          invalidRemoteUrl: 'значение не является корректной ссылкой: {0}',
          valueNotAString:
            'значение {0} должно быть строкой, попробуйте обернуть его в одинарные кавычки',
          invalidEnvironmentAction: `некорректное значение - {0}, доступные значения - {1}`,
          onStopJobIsNotDefined: `отсутствует объявленная задача остановки - {0}`,
          environmentIsNotDefined: `не объявлено окружение в задаче остановки - {0}`,
          differentEnvironmentName: `указаны различные окружения с задачей остановки - {0}`,
          actionStopIsNotDefined: `в задаче остановки {0} указан action отличный от 'stop'`,
          blankEnvironmentName: `не определено наименование окружения`,
          wrongEnvironmentName: `наименование окружения может содержать только латинские буквы, цифры, «-», «_», «/», «$», «{», «}» и пробелы, но не может начинаться или заканчиваться на «/»`,
          // ошибка для джобы
          environmentIsProtected: `Окружение, в которое выполняется развертывание, защищено. Только пользователи с достаточным доступом могут выполнить данную задачу.`,
          valueShouldBeStringArray: 'значение должно быть массивом строк',
          valueShouldBeArray: 'значение должно быть массивом',
          valueShouldBeInOptions: 'значение должно присутствовать в опциях'
        }
      },
      pipeline: {
        run: 'Запустить конвейер',
        createPipeline: 'Создание конвейера',
        ChooseRefPipeline: 'Выбрать тег | Выбрать ветку',
        restartVariables: {
          forTag: 'Вы уверены, что хотите сбросить кэш переменных в теге {0}?',
          forBranch: 'Вы уверены, что хотите сбросить кэш переменных на ветке {0}?'
        } ,
        clearRunnerCaches: 'Сбросить кэш задач',
        clearVariablesCaches: 'Сбросить кэш',
        descriptionVariables: "Укажите значения переменных, которые будут использоваться в этом запуске. По умолчанию используются переменные, указанные в файле конфигурации, а также <a target=\"_blank\" href=\"https://docs.gitflic.ru/cicd/cicd-settings/#variables\">настройки CI/CD</a>.<br>Переменные, указанные здесь, <b>раскрываются</b> и не <b>маскируются</b>",
        clearRunnerCachesConfirmation: 'Вы уверены, что хотите сбросить кэш для новых задач?',
        clearRunnerCachesDescription: 'Для всех новых задач кэш будет сброшен.',
        configuration: 'Конфигурация конвейера',
        restart: 'Перезапустить',
        restartConfirmation: 'Вы уверены, что хотите перезапустить все задачи, кроме успешных?',
        cancelPipeline: 'Отменить конвейер',
        cancelConfirmation: 'Вы уверены, что хотите отменить выполнение конвейера?',
        deleteConfirmation: 'Вы уверены, что хотите удалить конвейер?',
        isRunning: 'Конвейер запущен!',
        runnerCacheCleared: 'Кэш для новых задач сброшен!',
        deleted: 'Конвейер удален!',
        delete: 'Удалить',
        cancel: 'Отменить',
        confirm: 'Подтвердить',
        noUser: 'Нет пользователя',
        pipelineStatus: 'Статус',
        pipelineConveyor: 'Конвейер',
        pipelineInitiator: 'Инициатор',
        pipelineCommit: 'Коммит',
        pipelineStages: 'Стадии',
        pipelineDuration: 'Продолжительность',
        pipelineTaskId: 'ID задачи',
        pipelineTitle: 'Название',
        pipelineCovering: 'Покрытие',
        pipelineLaunchedBy: 'запустил',
        pipelineRestartMessage: 'Перезапустить',
        pipelineRestartMessageTooltip: 'Перезапуск конвейеров | Нет задач для перезапуска',
        pipelineForMessage: 'для',
        pipelineInMessage: 'за',
        pipelineNoLinkedMR: 'Нет связанного запроса на слияние',
        pipelineLinkedMR: 'Связанный запрос на слияние',
        create: 'Создать конвейер',
        configurationNotFound:
          'Файл конфигурации CI/CD, указанный в настройках проекта, не найден в стандартной ветке.',
        configurationNotFoundSolution:
          'Укажите | актуальный конфигурационный файл или | создайте новый',
        templateConfiguration: {
          title: 'Шаблонная конфигурация CI/CD',
          editedItem: 'Шаблон непрерывной интеграции и развертывания для {0} проекта',
          publishedItem: {
            title: 'Шаблон непрерывной интеграции и развертывания для публикации приложения в {0}.',
            files: 'В репозиторий будут добавлены файлы {0}.'
          },
          create: 'Создание шаблонной конфигурации CI/CD',
          createDescription:
            'Вы можете отредактировать шаблон конфигурационного файла ниже в зависимости от ваших потребностей. Подробнее о синтаксисе и ключевых словах можно узнать в | документации',
          createDiscard: 'Вы уверены, что хотите отменить создание конфигурации?',
          basic: 'Базовый шаблон GitFlic',
          basicDescription:
            'Для изучения работы CI/CD конвейеров и настройки конфигурации воспользуйтесь тестовым шаблоном для создания своего первого',
          basicAdded: 'Добавлен базовый шаблон конфигурации конвейеров'
        },
        parentWasDeleted: 'Родительский конвейер был удален',
        childWasDeleted: 'Дочерний конвейер был удален',
        mergeResultPipeline: 'Результат слияния',
        mergeRequestPipeline: 'Конвейер слияния',
        trainPipeline: 'Поезд слияния'
      },
      job: {
        jobLogRunning: 'Задача выполняется...',
        jobUploadMore: 'Загрузить еще',
        jobCancel: 'Отменить',
        jobConfirm: 'Подтвердить',
        jobLogError: 'Произошла ошибка при загрузке логов. Попробуйте перезагрузить страницу.',
        jobReload: 'Перезапустить',
        jobNoAccess: 'Нет доступа',
        jobNoLogs: 'Нет логов',
        jobConveyor: 'Конвейер',
        jobConveyorFor: 'для',
        jobStageSelect: 'Выберите стадию',
        jobDuration: 'Продолжительность',
        jobRunner: 'Раннер',
        jobCommit: 'Коммит',
        jobNoData: 'Нет данных',
        jobRestartConfirmation: 'Вы уверены, что хотите перезапустить задачу?',
        jobCancelConfirmation: 'Вы уверены, что хотите отменить выполнение задачи?',
        jobFailedTitle: 'Название',
        jobFailedStage: 'Стадия',
        jobFailedFail: 'Неудача',
        jobStatus: 'Статус',
        jobTask: 'Задача',
        jobInitiator: 'Инициатор',
        jobStage: 'Стадия',
        jobName: 'Имя',
        jobCovering: 'Покрытие',
        jobRetried: 'перезапущена'
      },
      stages: {
        stageReload: 'Вы уверены, что хотите перезапустить все задачи, кроме успешных?'
      },
      artifact: {
        artifactNumber: 'Номер',
        artifactJob: 'Задача',
        artifactFile: 'Файл',
        artifactFileType: 'Тип файла',
        artifactExpireAt: 'Истекает',
        artifactExpireAtNever: 'Никогда',
        artifactNone: 'Нет артефактов',
        artifactDeleteConfirmation: 'Вы уверены, что хотите удалить артефакт?',
        artifactUnlockConfirmation:
          'Срок действия артефакта истёк. При разблокировке, скачивание артефакта будет недоступно.',
        artifactUnlockConfirmationHead: 'Обратите внимание',
        artifactCancel: 'Отменить',
        artifactConfirm: 'Подтвердить',
        artifactFilter: 'Показывать только актуальные задачи',
        artifactDelete: 'Удалить',
        artifactDownload: 'Скачать',
        artifactIsDeleted: 'Артефакт удален',
        artifactLocked: 'Заблокировано',
        artifactUnlocked: 'Разблокировано',
        artifactIsExpired: 'Истёк'
      },
      scheduler: {
        schedulerTitle: 'Планировщик конвейеров',
        schedulerScheduleTitle: 'Расписание конвейеров',
        schedulerNewSchedule: 'Новое расписание',
        schedulerNoSchedules: 'Расписаний не найдено',
        schedulerCancel: 'Отменить',
        schedulerConfirm: 'Подтвердить',
        schedulerCreateTitle: 'Создание расписания',
        schedulerChooseBranch: 'Выбрать ветку',
        schedulerChooseBranchMessage: 'Выберите ветку *',
        schedulerChooseTag: 'Выбрать тег',
        schedulerChooseTagMessage: 'Выберите тег *',
        schedulerConfigFilePath: 'Путь конфигурационного файла CI/CD',
        schedulerConfigFilePathDescription:
          'Путь до конфигурационного файла указывается из корневого каталога',
        schedulerTimeZoneSelect: 'Выбор часовой зоны',
        schedulerCronExpression: 'Cron-выражение',
        schedulerDescriptionTitle: 'Описание',
        schedulerVariablesTitle: 'Переменные',
        schedulerCreate: 'Создать',
        schedulerShowValues: 'Показать значения',
        schedulerHideValues: 'Скрыть значения',
        schedulerEditTitle: 'Редактирование расписания',
        schedulerEditSave: 'Сохранить',
        scheduleSettings: 'Настройки',
        scheduleActivate: 'Активировать',
        scheduleDeactivate: 'Дективировать',
        scheduleActivated: 'Активен',
        scheduleDeactivated: 'Неактивен',
        scheduleStatusTitle: 'Статус',
        scheduleTargetTitle: 'Цель',
        scheduleDescriptionTitle: 'Описание',
        scheduleConfigurationTitle: 'Конфигурация',
        scheduleAuthorTitle: 'Автор',
        scheduleScheduleTitle: 'График',
        scheduleDelete: 'Удалить',
        scheduleVariableKey: 'Ключ',
        scheduleVariableValue: 'Значение',
        scheduleActivateConfirmation: 'Вы уверены, что хотите активировать расписание?',
        scheduleDeactivateConfirmation: 'Вы уверены, что хотите деактивировать расписание?',
        scheduleDeleteConfirmation: 'Вы уверены, что хотите удалить расписание?'
      }
    }
  }
};
